export default "__VITE_ASSET__edbbGPQJ__"